import { useEffect, useState } from "react";
import { workspacesService } from "features/workspaces/services/workspaces-service";
import type { WorkspacesResponse } from "features/workspaces/types";

export const useFetchWorkspaces = (): [WorkspacesResponse | undefined, boolean] => {
  const [workspaces, setWorkspaces] = useState<WorkspacesResponse>();
  const [isFetching, setIsFetching] = useState<boolean>(false);

  useEffect(() => {
    const abortController = new AbortController();

    async function fetchData() {
      setIsFetching(true);

      try {
        const response = await workspacesService.getWorkspaces(abortController);
        setWorkspaces(response);
      } catch (error) {
        console.error(error);
      }

      setIsFetching(false);
    }

    fetchData();

    return () => {
      abortController.abort();
    };
  }, []);

  return [workspaces, isFetching];
};
